import { keyframes, styled } from "@mui/material/styles";
import React from "react";

interface Props {
  small?: boolean;
}

const LoadingAnimation = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }`;

const LoadingContainer = styled("div")<Props>`
  height: 100%;
  width: 100%;
  .ea-loading-mask {
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: transparent;
    &.ea-opaque .ea-loading-color {
      opacity: 1;
    }
    .ea-loading-text {
      text-indent: -4000px;
      text-align: center;
      position: absolute;
    }
    .ea-loading-image {
      ${(props) => (props.small ? "font-size: 2em;" : "font-size: 4em;")}
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      border-width: 0.015em;
      &:before,
      &:after {
        position: absolute;
        top: 50%;
        left: 50%;
        display: inline-block;
        content: "";
        box-sizing: inherit;
        border-radius: 50%;
        border-width: 0.05em;
        border-style: solid;
        border-color: currentColor;
        border-top-color: transparent;
        border-bottom-color: transparent;
        &:before {
          margin-top: -0.5em;
          margin-left: -0.5em;
          width: 1em;
          height: 1em;
          animation: ${LoadingAnimation} 0.7s linear infinite;
        }
        &:after {
          margin-top: -0.25em;
          margin-left: -0.25em;
          width: 0.5em;
          height: 0.5em;
          animation: ${LoadingAnimation} 1.4s linear reverse infinite;
        }
      }
    }
    .ea-loading-color {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: transparent !important;
      opacity: 0 !important;
    }
  }
`;

export function LoadingGraphic(props: Props) {
  return (
    <LoadingContainer small={props.small}>
      <div className="ea-loading-mask">
        <span className="ea-loading-text">Loading</span>
        <div className="ea-loading-image"></div>
        <div className="ea-loading-color"></div>
      </div>
    </LoadingContainer>
  );
}
